"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _themes = _interopRequireWildcard(require("./themes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getTheme = function getTheme(brand, localTheme, noBaseTheme) {
  if (localTheme === void 0) {
    localTheme = {};
  }
  // Special handling for 'base' value, but we should remove if safe.
  if (!brand || brand === 'base') {
    return (0, _deepmerge.default)(_themes.baseTheme, localTheme);
  }
  var brandTheme = _themes.default[brand];
  if (brandTheme == null) {
    throw new Error("Missing theme for brand '" + brand + "'");
  }
  if (noBaseTheme) {
    return (0, _deepmerge.default)(brandTheme, localTheme);
  }
  return _deepmerge.default.all([_themes.baseTheme, brandTheme, localTheme]);
};
var _default = exports.default = getTheme;